import { render } from "./Spinner.vue?vue&type=template&id=b286cc8e&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=b286cc8e&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-b286cc8e"

export default script